import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
// import svg from '../../../../img/symbol.svg'
function ProgressBar(props) {
    const {activeTab}=props
    return (
        <ul className="progress-bar">
        <li className={`${activeTab>=1?'active':''}`}>
            <span className="progress-flex">
                <h4>Personal Information</h4>
                <span className="progress-icons">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                    >
                        <path d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216h40C512,443.62,485.371,379.333,437.02,330.98zM256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40c59.551,0,108,48.448,108,108S315.551,256,256,256z" />
                    </svg>
                </span>
            </span>
        </li>
        <li className={`${activeTab>=2?'active':''}`}>
            <span className="progress-flex">
                <h4>Schedule</h4>
                <span className="progress-icons">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 359.286 359.286"
                    >
                        <path d="m179.643 359.286c99.043 0 179.643-80.6 179.643-179.643s-80.599-179.643-179.643-179.643-179.643 80.6-179.643 179.643 80.6 179.643 179.643 179.643zm0-335.334c85.869 0 155.691 69.821 155.691 155.691s-69.821 155.691-155.691 155.691-155.691-69.821-155.691-155.691 69.822-155.691 155.691-155.691z" />
                        <path d="m232.039 236.89c2.216 1.796 4.85 2.635 7.485 2.635 3.533 0 7.006-1.557 9.341-4.491 4.132-5.15 3.293-12.695-1.856-16.827l-55.39-44.312v-90.061c0-6.587-5.389-11.976-11.976-11.976s-11.976 5.389-11.976 11.976v95.81c0 3.653 1.677 7.066 4.491 9.341z" />
                    </svg>
                </span>
            </span>
        </  li>
        <li className={`${activeTab>=3?'active':''}`}>
            <span className="progress-flex">
                <h4>Payment</h4>
                <span className="progress-icons">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 32 32"
                    >
                        <path d="m26.67 4.28h-21.3a5.33 5.33 0 0 0 -5.37 5.33v12.79a5.33 5.33 0 0 0 5.33 5.33h16a1.07 1.07 0 1 0 0-2.13h-16a3.2 3.2 0 0 1 -3.2-3.2v-5.33h24.52a1.07 1.07 0 0 0 0-2.13h-24.48v-5.33a3.2 3.2 0 0 1 3.2-3.2h21.3a3.2 3.2 0 0 1 3.2 3.2v1.07h-24.52a1.07 1.07 0 0 0 0 2.13h24.52v3.19a1.07 1.07 0 0 0 2.13 0v-6.39a5.33 5.33 0 0 0 -5.33-5.33z" />
                        <path d="m31.25 19.25-3.2-1.07a1.07 1.07 0 0 0 -.67 0l-3.2 1.07a1.07 1.07 0 0 0 -.73 1v2a5.31 5.31 0 0 0 2.37 4.43l1.3.87a1.07 1.07 0 0 0 1.18 0l1.3-.87a5.31 5.31 0 0 0 2.4-4.44v-2a1.07 1.07 0 0 0 -.75-.99zm-1.4 3a3.19 3.19 0 0 1 -1.42 2.66l-.71.47-.72-.48a3.19 3.19 0 0 1 -1.42-2.66v-1.24l2.13-.71 2.13.71z" />
                        <path
                            xmlns="http://www.w3.org/2000/svg"
                            d="m5.35 21.34a1.07 1.07 0 0 0 0 2.13h3.21a1.07 1.07 0 0 0 0-2.13z"
                        />
                    </svg>
                </span>
            </span>
        </li>
    </ul>
    );
}

export default ProgressBar;